module.exports = __webpack_public_path__ + "img/Disminución de Deducible.4db87941.svg";